$(document).ready(function () {
  // SECTION Mapbox

  // ANCHOR Lazy loading de la carte
  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  // ANCHOR Récupération AJAX des points
  function getStoresMarkers() {
    let call_response;
    return new Promise(function (resolve, reject) {
      $.ajax({
        url: "https://www.cyclable.com/wp-content/themes/cyclable-magasin-2019/assets/js/ajax/getStores.php",
        type: "GET",
        dataType: "json",
        contentType: "text/plain; charset=utf-8",
        crossDomain: true,
        success: function (result, status) {
          resolve(result);
        },
        error: function (result, status, error) {
          console.log(result, status, error);
          resolve(result);
        },
      });
    }).then(function (result) {
      // Convertir les IDs en number pour la comparaison stricte
      if (Array.isArray(result)) {
        result.forEach((store) => {
          store.id = parseInt(store.id);
          if (store.id_ps) store.id_ps = parseInt(store.id_ps);
        });
      }
      return result;
    });
  }

  // ANCHOR Paramètres du magasin actuel
  let store_id = parseInt($("#map").attr("data-store-id"));
  let store_lat = $("#map").attr("data-store-lat");
  let store_lng = $("#map").attr("data-store-lng");
  let store_marker;
  let store_popup;
  let marker_center = [store_lng, store_lat];

  // ANCHOR Paramètres globaux
  let map;
  let cyclable_map_stores;
  let is_map_visible = false;
  let is_map_loaded = false;

  // ANCHOR Paramètres du navigateur
  let today_date = new Date();
  let cache_version = "v2"; // Incrémenter pour forcer refresh
  let local_stores = localStorage.getItem(
    "cyclable_map_stores_" + cache_version
  );
  let local_stores_refresh = localStorage.getItem(
    "cyclable_map_refresh_" + cache_version
  );

  // ANCHOR Paramètres MAPBOX
  let map_accesstoken =
    "pk.eyJ1IjoiY3ljbGFibGUtd2ViIiwiYSI6ImNrZnNjNngwMTA3cDYycWxyZWcxNXgydWsifQ.DTC0Dak_n07HwBOCjXDzoA";
  let map_features = [];

  let magasins_features = [];
  let services_features = [];

  let map_center = [1.7191, 46.7111];
  let map_bounds = [
    [-17.4534286 /* ← */, 39.2632185 /* ↓ */],
    [20.8678344 /* → */, 54.268318 /* ↑ */],
  ];

  // ANCHOR Ajustement du canvas
  $(window).on("resize scroll", function () {
    if (
      $("#localiser").length &&
      $("#localiser").isInViewport() &&
      !is_map_visible
    ) {
      setMapbox();
      is_map_visible = true;
    }
  });

  // ANCHOR
  function setMapbox() {
    // Si aucune liste de magasin n'a été trouvée dans le cache
    // Ou si la date de refresh est supérieur à 1j
    if (
      1 ||
      !local_stores ||
      !local_stores_refresh ||
      today_date.getTime() - local_stores_refresh > 80000000
    ) {
      // On récupère la liste des magasins
      getStoresMarkers().then((stores) => {
        stores.forEach((store) => {
          // On différencie le magasin actif via une classe spécifique
          store.className = store.id === store_id ? "active-marker-popup" : "";
          if (store.rating === false) store.rating = "Aucun avis";

          let googleItinerary = encodeURIComponent(store.name);
          // if(store.id == "84") {
          // 	googleItinerary = "58+Av.+Ren%C3%A9+Coty,+76600+Le+Havre";
          // }

          let parsedRating = parseFloat(store.rating);

          if (!isNaN(parsedRating)) {
            parsedRating = parsedRating.toFixed(1);
          } else {
            parsedRating = "Aucun avis";
          }

          // HTML du popup
          store.popup_html =
            "<div class='store-marker-popup " +
            store.className +
            "'>" +
            "<div>" +
            "<p class='store-title'>" +
            store.name +
            "</b>" +
            "<p class='store-address'>" +
            store.address1 +
            " <br> " +
            store.address2 +
            " </p>" +
            "<div class='store-map-btns'>" +
            "<div class='store-map-btns-row'>" +
            // NOTES
            "<a class='store-marker-stars" +
            (!store.rating ? " no-rating" : "") +
            "' href='https://search.google.com/local/reviews?placeid=" +
            store.placeid +
            "' target='_blank' title='Voir les avis'>" +
            "<span class='stars-text'>" +
            parsedRating +
            '</span><span class="Stars" style="--rating: ' +
            parsedRating +
            ';"></span>' +
            "</a>" +
            "</div>" +
            "<div class='store-map-btns-row'>" +
            // PAGE
            "<a class='store-map-btn store-marker-page' href=" +
            store.page +
            " target='_blank' title='Voir la page du magasin'>" +
            '<svg stroke="currentColor" fill="none" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>' +
            "<small>Informations</small></a>" +
            // AGRANDIR
            "<a class='store-map-btn store-marker-fullscreen' href='https://www.google.com/maps/?q=" +
            googleItinerary +
            // +"/"+coordinates[1]+","+coordinates[0]+",18.5z'
            "' target='_blank' title='Agrandir le plan'>" +
            '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M5 5L10 5 10 3 3 3 3 10 5 10zM10 19L5 19 5 14 3 14 3 21 10 21zM21 14L19 14 19 19 14 19 14 21 21 21zM19 10L21 10 21 3 14 3 14 5 19 5z"></path></svg>' +
            "<small>Agrandir</small></a>" +
            "</div>" +
            "</div>" +
            "</div>" +
            "<div>" +
            // Itinéraire
            "<a class='store-map-btn store-marker-route' href='https://www.google.com/maps/dir/?api=1&destination=" +
            googleItinerary +
            // +"/"+coordinates[1]+","+coordinates[0]+",18.5z'
            "&destination_place_id=" +
            store.placeid +
            "&travelmode=driving' target='_blank' title='Trouver un itinéraire vers ce magasin'>" +
            '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke="#000" stroke-width="2" d="M17,11 L22,6 L17,1 M22,6 L18,6 C14.686,6 12,8.686 12,12 L12,24 M7,6 L2,11 L7,16 M2,11 L6,11 C9.314,11 12,13.686 12,17 L12,24"></path></svg>' +
            "<small>Itinéraire</small></a>" +
            // AGRANDIR
            "<a class='store-map-btn store-marker-app' href='https://www.google.com/maps/?q=" +
            googleItinerary +
            // +"/"+coordinates[1]+","+coordinates[0]+",18.5z'
            "' target='_blank' title='Ouvrir sur Google Maps'>" +
            '<img height="40px" src="/wp-content/themes/cyclable-magasin-2019/assets/img/Google_Maps_Logo.svg" title="Google Maps"/>' +
            "</a>" +
            "</div>" +
            "</div>";

          let color_store = "#b2252b";
          let color_services = "#303028";

          // Feature du magasin
          let map_feature_item = {
            type: "Feature",
            properties: {
              id: store.id,
              name: store.name,
              address1: store.address1,
              address2: store.address2,
              page: store.page,
              rating: store.rating,
              placeid: store.placeid,
              popup_className: store.className,
              popup_html: store.popup_html,
              is_service: store.is_service,
              icon:
                store.is_service == 1
                  ? "custom-marker-services"
                  : "custom-marker",
              color: store.is_service == 1 ? color_services : color_store,
            },
            geometry: {
              type: "Point",
              coordinates: [store.longitude, store.latitude],
            },
          };

          // On regroupe tous les points, magasin comme service
          map_features.push(map_feature_item);

          // On regroupe les magasins et les cyclable services séparément
          // Pour l'instant, non utilisé
          if (store.is_service == 1) {
            services_features.push(map_feature_item);
          } else {
            magasins_features.push(map_feature_item);
          }

          // Si le store est celui sélectionné, on le définit comme marker global
          if (store.id === store_id) {
            store_marker = map_feature_item;
          }

          // 🚨 EXCEPTION TEMPORAIRE : Champigny blog 97 affiche toujours Champigny (ID 85)
          if (
            window.location.hostname === "champigny-sur-marne.cyclable.com" &&
            store.name.includes("Champigny")
          ) {
            store_marker = map_feature_item;
          }
        });

        // On stocke les données récupérées en cache
        localStorage.setItem(
          "cyclable_map_stores_" + cache_version,
          JSON.stringify(map_features)
        );
        localStorage.setItem(
          "cyclable_map_refresh_" + cache_version,
          JSON.stringify(today_date.getTime())
        );

        loadMapbox(map_features);
      });
    }
    // Si des données sont présentes en cache
    else {
      cyclable_map_refresh = JSON.parse(
        localStorage.getItem("cyclable_map_refresh_" + cache_version)
      );
      cyclable_map_stores = JSON.parse(
        localStorage.getItem("cyclable_map_stores_" + cache_version)
      );
      cyclable_map_magasins = cyclable_map_stores.filter(
        (x) => x.is_service === 0
      );
      cyclable_map_services = cyclable_map_stores.filter(
        (x) => x.is_service === 1
      );

      // On récupère le marker principal
      cyclable_map_stores.forEach((map_feature_item) => {
        if (map_feature_item.properties.id === store_id)
          store_marker = map_feature_item;
      });

      loadMapbox(cyclable_map_stores);
    }
  }

  // ANCHOR Boutons custom Mapbox
  class MapboxGLButtonControl {
    constructor({ className = "", title = "", eventHandler = evtHndlr }) {
      this._className = className;
      this._title = title;
      this._eventHandler = eventHandler;
    }

    onAdd(map) {
      this._btn = document.createElement("button");
      this._btn.className = "mapboxgl-ctrl-icon" + " " + this._className;
      this._btn.type = "button";
      this._btn.title = this._title;
      this._btn.onclick = this._eventHandler;

      this._container = document.createElement("div");
      this._container.className =
        "mapboxgl-ctrl-group mapboxgl-ctrl mapboxgl-ctrl-custom";
      this._container.appendChild(this._btn);

      return this._container;
    }

    onRemove() {
      this._container.parentNode.removeChild(this._container);
      this._map = undefined;
    }
  }

  // ANCHOR Dé-zoom sur toute la France
  function dezoom() {
    // On masque le bouton pour dézoomer
    $(".mapbox-gl-dezoom").hide();

    // Masquer les pop up divers
    if (store_popup && $(".mapboxgl-popup").is(":visible"))
      store_popup.remove();

    // Déplacement sur la carte
    if ($("#map").width() > 850) {
      map.flyTo({
        center: map_center,
        zoom: 5.2,
        speed: 0.8,
        curve: 1.1,
      });
    } else {
      map.flyTo({
        center: map_center,
        zoom: 4.4,
      });
    }
  }

  // ANCHOR Retour au marqueur principal
  function recenter() {
    // On masque les pop up existantes
    if (store_popup && $(".mapboxgl-popup").is(":visible"))
      store_popup.remove();

    // On se déplace sur la carte
    map.flyTo({
      center: marker_center,
      zoom: 15,
    });

    // On affiche le pop up du magasin actuel
    let popup_html = store_marker.properties.popup_html;
    let coordinates = store_marker.geometry.coordinates.slice();
    store_popup = new mapboxgl.Popup({ closeOnClick: true, maxWidth: 320 })
      .setLngLat(coordinates)
      .setHTML(popup_html)
      .addTo(map);
  }

  // Action bind pour le bouton de dézoom sur la France
  const unZoom = new MapboxGLButtonControl({
    className: "mapbox-gl-dezoom",
    title: "Voir tous les magasins",
    eventHandler: dezoom,
  });

  // Action bind pour le bouton de zoom sur le marker initial
  const resetMarker = new MapboxGLButtonControl({
    className: "mapbox-gl-resetzoom",
    title: "Recentrer sur le magasin",
    eventHandler: recenter,
  });

  // ANCHOR Affichage de la carte lorsque tout est bien chargé
  function sourceCallback() {
    let map_size = $(".mapboxgl-canvas").width();
    let parent_size = $("#map").width();

    if (map_size != parent_size || Math.abs(parent_size - map_size) < 5) {
      $("#map").fadeIn("fast", function () {
        $(".map-preview").remove();
        $(".bike-loading").remove();
        map.resize();
      });
      is_map_loaded = true;
    }
  }

  // Déplacement sur un marker bien spécifique
  function focusMarker(store) {
    if (store_popup) store_popup.remove();

    let coordinates = store.geometry.coordinates.slice();
    let popup_html = store.properties.popup_html;

    store_popup = new mapboxgl.Popup({ closeOnClick: true, maxWidth: 320 })
      .setLngLat(coordinates)
      .setHTML(popup_html)
      .addTo(map);

    map.flyTo({
      center: store.geometry.coordinates,
      zoom: 16,
    });
  }

  // ANCHOR Chargement de la carte avec les données
  function loadMapbox(map_features) {
    mapboxgl.accessToken = map_accesstoken;

    // Initialisation de la map
    map = new mapboxgl.Map({
      container: "map",
      style:
        "mapbox://styles/cyclable-web/ckgkjq3ii03pz19san9y5jpia?optimize=true",
      center: marker_center,
      zoom: 16,
      minzoom: 4,
      maxzoom: 18,
      attributionControl: false,
      maxBounds: map_bounds,
    });

    map.on("load", function () {
      // On retire les boutons inutiles
      map.scrollZoom.disable();
      map.doubleClickZoom.disable();

      // On retire la fonctionnalité de rotation de la carte
      map.dragRotate.disable();
      map.touchZoomRotate.disableRotation();

      map.addControl(
        new mapboxgl.GeolocateControl({
          positionOptions: {
            enableHighAccuracy: true,
          },
          trackUserLocation: true,
        })
      );

      // On charge l'image du marker custom pour les magasins et les cyclable services
      let icon_map_store =
        "/wp-content/themes/cyclable-magasin-2019/assets/img/store_marker.png";
      let icon_map_services =
        "/wp-content/themes/cyclable-magasin-2019/assets/img/services_marker.png";

      const map_images = [
        { url: icon_map_store, id: "custom-marker" },
        { url: icon_map_services, id: "custom-marker-services" },
      ];

      map_images.forEach((img) => {
        map.loadImage(img.url, function (error, res) {
          map.addImage(img.id, res);
        });
      });

      // ANCHOR Source de la carte : les données à afficher
      map.addSource("stores", {
        type: "geojson",
        cluster: true,
        clusterRadius: 40, // rayon de clustering
        clusterMaxZoom: 14, // périmètre max zoom
        data: {
          type: "FeatureCollection",
          features: map_features, // Objet regroupant tous les points
        },
      });

      // On ajoute le popup principal
      let popup_html = store_marker.properties.popup_html;
      let coordinates = store_marker.geometry.coordinates.slice();
      store_popup = new mapboxgl.Popup({ closeOnClick: true, maxWidth: 320 })
        .setLngLat(coordinates)
        .setHTML(popup_html)
        .addTo(map);

      // On ajoute les boutons de navigation
      map.addControl(new mapboxgl.NavigationControl());

      map.addLayer({
        id: "store-point",
        type: "symbol",
        source: "stores",
        layout: {
          "text-ignore-placement": true,
          "text-allow-overlap": true,
          "icon-image": ["get", "icon"],
          "icon-anchor": "bottom",
        },
      });

      // ANCHOR Ajout des labels
      map.addLayer({
        id: "store-point-label",
        type: "symbol",
        source: "stores",
        minzoom: 6, // Niveau de zoom minimum pour afficher les labels
        layout: {
          "icon-allow-overlap": true,
          "text-allow-overlap": false,
          "text-field": "{name}", // Donnée affichée sur le label, en fonction du store
          "text-variable-anchor": ["bottom"],
          "text-radial-offset": 3,
          "text-font": ["Open Sans Semibold"],
          "text-justify": "center",
          "text-size": 13,
        },
        paint: {
          "text-color": ["get", "color"],
          "text-halo-color": "#ffffff",
          "text-halo-width": 1,
          "text-halo-blur": 1,
        },
      });

      // ANCHOR Ajout des clusters
      map.addLayer({
        id: "clusters",
        type: "circle",
        source: "stores",
        filter: ["has", "point_count"],
        paint: {
          "circle-color": "#b40923",
          "circle-radius": 16,
        },
      });

      // ANCHOR Ajout du nb de magasins sur les clusters
      map.addLayer({
        id: "cluster-count",
        type: "symbol",
        source: "stores",
        filter: ["has", "point_count"],
        layout: {
          "text-field": "{point_count_abbreviated}",
          "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
          "text-size": 12,
        },
        paint: {
          "text-color": "#ffffff",
        },
      });

      // ANCHOR Action sur les clusterss
      map.on("click", "clusters", function (e) {
        var features = map.queryRenderedFeatures(e.point, {
          layers: ["clusters"],
        });
        var clusterId = features[0].properties.cluster_id;
        map
          .getSource("stores")
          .getClusterExpansionZoom(clusterId, function (err, zoom) {
            if (err) return;

            map.flyTo({
              center: features[0].geometry.coordinates,
              zoom: zoom + 2,
            });
          });
      });

      // ANCHOR Bind move : loading
      map.on("movestart", ({ originalEvent }) => {
        if (!originalEvent && is_map_loaded) {
          $(".map-ongoing-loading").show();
        }
      });

      map.on("moveend", ({ originalEvent }) => {
        if (!originalEvent && is_map_loaded && $("#map").is(":visible")) {
          setTimeout(function () {
            $(".map-ongoing-loading").hide();
          }, 1000);
        }
      });
      // Ajout des deux boutons custom (dezoom et resetzoom)
      map.addControl(resetMarker, "bottom-left");
      map.addControl(unZoom, "bottom-left");
      $("." + unZoom._className).tooltip({
        delay: 0,
        placement: "right",
        title: unZoom._title,
        html: true,
      });
      $("." + resetMarker._className).tooltip({
        delay: 0,
        placement: "right",
        title: resetMarker._title,
        html: true,
      });
      // Trigger de la fonction d'affichage lorsque le chargement est terminé
      map.on("sourcedata", sourceCallback);
      // ANCHOR Au clic sur un point
      map.on("click", "store-point", function (e) {
        focusMarker(e.features[0]);
      });
      map.on("click", "store-point-label", function (e) {
        focusMarker(e.features[0]);
      });
      // ANCHOR Au zoom
      map.on("zoom", "store-point", function (e) {
        if (map.getZoom() > 6 && !$(".mapbox-gl-dezoom").is(":visible")) {
          $(".mapbox-gl-dezoom").show();
          $(".mapbox-gl-dezoom").tooltip("show");
        } else if (map.getZoom() < 6 && $(".mapbox-gl-dezoom").is(":visible")) {
          $(".mapbox-gl-dezoom").hide();
          $(".mapbox-gl-dezoom").tooltip("hide");
        }
      });
      // ANCHOR Customisation du curseur
      map.on("mouseenter", "store-point", function () {
        map.getCanvas().style.cursor = "pointer";
      });
      map.on("mouseleave", "store-point", function () {
        map.getCanvas().style.cursor = "";
      });
      map.on("mouseenter", "clusters", function () {
        map.getCanvas().style.cursor = "pointer";
      });
      map.on("mouseleave", "clusters", function () {
        map.getCanvas().style.cursor = "";
      });
      map.resize();
    });
  }
  // !SECTION
});
